import Add from './add';
import Loot from './loot';

export default {
    Add,
    Loot
}